<template>
    <el-dialog title="新增台账信息" :visible.sync="dialogFormVisible" :before-close="close" :close-on-click-modal="false">
        <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px">
            <el-form-item label="使用者1" :label-width="formLabelWidth" prop="USER_NAME_1">
                <el-select v-model="form.USER_NAME_1" placeholder="请选择使用者1">
                    <el-option v-for="(item, key) of formData" :key="key" :label="item.USER_NAME" :value="item.USER_NAME"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="使用者2" :label-width="formLabelWidth" prop="USER_NAME_2">
                <el-select v-model="form.USER_NAME_2" placeholder="请选择使用者2">
                    <el-option v-for="(item, key) of formData" :key="key" :label="item.USER_NAME" :value="item.USER_NAME"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="使用者量" :label-width="formLabelWidth" prop="USE_VOLUME">
                <el-input v-model="form.USE_VOLUME"></el-input>
            </el-form-item>

            <el-form-item label="使用日期" :label-width="formLabelWidth" prop="DATE">
                <el-date-picker value-format="yyyy-MM-dd" v-model="form.DATE" type="date" placeholder="选择日期"> </el-date-picker>
            </el-form-item>
            <el-form-item label="使用时间" :label-width="formLabelWidth" prop="TIME">
                <el-time-picker v-model="form.TIME" class="date-box" format="HH:mm" value-format="HH:mm" placeholder="选择时间"> </el-time-picker>
            </el-form-item>
            <el-form-item label="备注" :label-width="formLabelWidth" prop="REMARK">
                <el-input v-model="form.REMARK"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="makeSure('ruleForm')">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script type="text/ecmascript-6">
    import parameterMessage from 'api/Message/parameterMessage.js'
    const _parameterMessage = new parameterMessage()
    const baseForm = {
        USER_NAME_1: '',
        USER_NAME_2: '',
        DATE: '',
        TIME: '',
        REMARK: '',
        USE_VOLUME:''
    }

    export default {
      props: {
        dialogFormVisible: Boolean,
        storageNum:String
      },

      data() {
      const validateUser = (rule, value, callback) => {
          if (value === '') {
              callback(new Error('请选择使用人2'))
          } else if (value === this.form.USER_NAME_1) {
                  callback(new Error('两个使用人不能为同一个人'))
              } else {
                  callback()
              }
          }
        return {
          form: baseForm,
          formLabelWidth: '120px',
          formData:[],
          userList:[],
          rules: {
            USER_NAME_1: [
              { required: true, message: '请选择使用者1', trigger: 'blur' }
            ],
            USER_NAME_2: [
              { required: true,  validator: validateUser, trigger: 'blur' }
            ]
          }
        }
      },
      methods: {
          async submitForm() {
           this.form.STORAGE_NO = this.storageNum
           this.formData.forEach(item =>{
               if(item.USER_NAME === this.form.USER_NAME_1){
                   this.form.USER_ID_1 = item.USER_ID
               }
               if(item.USER_NAME === this.form.USER_NAME_2){
                   this.form.USER_ID_2 = item.USER_ID
               }
           })
              _parameterMessage.addParameter(this.form.REMARK,this.form.STORAGE_NO,this.form.USER_ID_1,this.form.USER_ID_2,this.form.USER_NAME_1,
                this.form.USER_NAME_2,this.form.USE_VOLUME, this.form.DATE,this.form.TIME)
                  .then(res => {
                      this.$message({
                          message: '新增台账信息！',
                          type: 'success'
                      })
                  }).catch((err)=>{
                this.$message.error('新增失败')
              })
              this.$refs['ruleForm'].resetFields()

          this.close()
        },
        makeSure(formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.submitForm()
            } else {
              console.log('error submit!!')
              return false
            }
          })
        },
        close() {
          this.$emit('controlFormWindow', false)
        },
        async getParameterUser(){
            let list = 'all'
            const res = await _parameterMessage.getParameterUser(5000,1,list)
            this.formData = res.items
        },

      },
      mounted(){
        this.getParameterUser()
      },
      components: {

      },
      watch: {
      }
    }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus"></style>
